import React from "react";

function LegalResearch() {

  return (
    <div>Legal Research</div>
  );
}
export default LegalResearch;
